// authActions.js
import { authenticator } from './auth-funcs'; // Your singleton authenticator
import { loginSlice } from '../redux/login'
import { userProfileSlice } from '../redux/profileData';
import { jobsSlice } from '../redux/appliedJobs';
import { jobCardSlice } from '../redux/applyCards';
import { referralSlice } from '../redux/referralData';
import { emailSlice } from '../redux/emails';
import { clearAnswerReviews } from '../redux/answerReviews';
import { clearScoreboard } from '../redux/scoreboard';
import logger from '../utils/logger';
import { resetAnalytics } from '../utils/analytics';
import { removeAllQuizAnswers } from '../utils/quizStorage';
import { markSignedOut } from './sessionEnded';


/**
 * Clears every slice that holds data belonging to a specific signed-in user.
 *
 * Run this on EVERY way a session can end — the explicit logout button, a Hub
 * `signedOut` event, and a failed token refresh — not just the button. Slices
 * left populated are handed straight to whoever signs in next: the mailbox, for
 * instance, skips its initial fetch when `fiftyEmailsLoaded` is already true, so
 * a stale deck renders under the new account until a hard reload.
 *
 * Anything user-scoped added to the store later belongs in this list.
 */
export const resetUserScopedData = (dispatch) => {
    dispatch(userProfileSlice.actions.clearUserProfileData());
    dispatch(jobsSlice.actions.clearAllData());
    dispatch(jobCardSlice.actions.clearJobCards());
    dispatch(referralSlice.actions.clearReferralData());
    dispatch(emailSlice.actions.clearEmailData());
    dispatch(clearAnswerReviews());
    dispatch(clearScoreboard());
    // The signup quiz keeps a user's half-finished answers in localStorage (utils/quizStorage.js). They
    // belong to the session that is ending, so they go with it. The answers the quiz could not save are a
    // different store, kept for the user until the profile has saved them, and are left alone.
    removeAllQuizAnswers();
};

/** resetUserScopedData plus the auth slice itself — use when the session ends. */
export const resetAllUserState = (dispatch) => {
    dispatch(loginSlice.actions.resetLoginState());
    dispatch(loginSlice.actions.markSessionEnded());
    markSignedOut();
    resetUserScopedData(dispatch);
};

// Thunk action creator for logout
export const handleLogout = (navigate) => async (dispatch) => {
    try {
        // Dispatch Redux actions to clear state
        resetAllUserState(dispatch);

        // Perform sign-out
        await authenticator.handleSignOut();
        resetAnalytics();

        // Navigate to sign-in page
        if (navigate) {
            navigate('/signin');
        }
    } catch (error) {
        logger.error('Logout failed:', error);
        // Optionally dispatch an error action or rethrow the error
        throw error;
    }
};
